import { EV4bClientErrorCategory } from "@/data/api/kili/common/kili-errors.type";
import { V4bClientError } from "@/data/api/v4b/error/v4b-client-error.types";

export function getV4bErrorCode(error: unknown) {
  if (error instanceof V4bClientError) {
    if (
      error.error.errorCategory === EV4bClientErrorCategory.DOMAIN_ERROR ||
      error.error.errorCategory === EV4bClientErrorCategory.TECHNICAL_ERROR
    ) {
      return error.error.errorDetails?.errorCode;
    }
  }

  return undefined;
}
